import React, { useState, useRef, useEffect } from "react";
import ReactPlayer from "react-player";
import { Link, useNavigate } from "react-router-dom";
import NavBar from "../../../components/Navbar/NavbarDashboard";
import { NavLink } from "react-router-dom";
import { AiFillBank } from "react-icons/ai";
import { Fa42Group } from "react-icons/fa6";
import { MdArrowBackIosNew } from "react-icons/md";
import { BiHomeAlt } from "react-icons/bi";
import { BiPlay } from "react-icons/bi";
import { BsPlayCircleFill } from "react-icons/bs";
import { BsPauseCircleFill } from "react-icons/bs";
import { MdOutlineRepeatOn } from "react-icons/md";
import { quizQuestions } from "../../../assets/questions/quizquestions";
import videoSource from "../../../assets/videos/videosource";
import { Box, Grid } from "@mui/material";
import { Container } from "react-bootstrap";
import { CenterFocusStrong } from "@mui/icons-material";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import BGImage from "../../../assets/images/RS_BG_10.png";
import Button from "@mui/material/Button";
import ArrowBackIosNewRoundedIcon from "@mui/icons-material/ArrowBackIosNewRounded";
import ArrowForwardIosRoundedIcon from "@mui/icons-material/ArrowForwardIosRounded";

const QuizPage = () => {
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [userAnswers, setUserAnswers] = useState(
    Array(quizQuestions.length).fill("")
  );
  const [videoPlayed, setVideoPlayed] = useState(false);
  const [quizFinished, setQuizFinished] = useState(false);
  const [isVideoEnded, setIsVideoEnded] = useState(false);
  const [showPrompt, setShowPrompt] = useState(false);
  const playerRef = useRef(null);

  const currentVideo = videoSource.find(
    (video) => video.id === quizQuestions[currentQuestionIndex].videoId
  );

  const handleOptionSelect = (option) => {
    const updatedAnswers = [...userAnswers];
    updatedAnswers[currentQuestionIndex] = option;
    setUserAnswers(updatedAnswers);
  };

  const handlePlayVideo = () => {
    setVideoPlayed(true);
    setIsVideoEnded(false);
    playerRef.current.seekTo(0);
  };

  const handlePauseVideo = () => {
    setVideoPlayed(false);
  };

  const handleRepeatVideo = () => {
    setVideoPlayed(true);
    setIsVideoEnded(false);
    playerRef.current.seekTo(0);
  };

  const handleNextQuestion = () => {
    if (currentQuestionIndex + 1 < quizQuestions.length) {
      setCurrentQuestionIndex(currentQuestionIndex + 1);
      setVideoPlayed(false);
      setIsVideoEnded(false);
      setShowPrompt(false); // Hide the prompt for the next question
    } else {
      // Quiz is finished
      setQuizFinished(true);
    }
  };

  const handleVideoEnd = () => {
    setIsVideoEnded(true);
  };

  const handleCheckAnswer = () => {
    if (
      userAnswers[currentQuestionIndex] !==
      quizQuestions[currentQuestionIndex].correctAnswer
    ) {
      setShowPrompt(true);
    } else {
      setShowPrompt(false);
      handleNextQuestion();
    }
  };

  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
    ...theme.typography.body2,
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  }));

  return (
    <Box
      sx={{
        backgroundImage: `url(${BGImage})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
        height: "100vh",
        justifyItem: "center",
      }}
    >
      <Box sx={{}}>
        <NavBar />
        <Box sx={{ marginLeft: "50px" }}>
          <Box sx={{}}>
            <Grid
              container
              spacing={"10px"}
              direction="row"
              alignItems="stretch"
              style={{}}
            >
              <Grid container xs={8} md={2} lg={4} style={{}}>
                <Grid
                  container
                  style={{
                    width: "100vh",
                  }}
                >
                  <Grid
                    item
                    xs={12}
                    style={{
                      borderRadius: "20px",
                      backgroundColor: "rgba(255, 255, 255, 0.5)",
                      boxShadow:
                        "rgba(0, 0, 0, 0.4) 0px 2px 4px, rgba(0, 0, 0, 0.3) 0px 7px 13px -3px, rgba(0, 0, 0, 0.2) 0px -3px 0px inset",
                    }}
                  >
                    <Grid
                      container
                      direction="row"
                      style={{
                        paddingBottom: "20px",
                      }}
                    >
                      <Grid
                        item
                        xs={2}
                        lg={2}
                        style={{
                          paddingTop: "53px",
                          paddingLeft: "65px",
                        }}
                      >
                        <Link to="/fundamentals">
                          <ArrowBackIosNewRoundedIcon />
                        </Link>
                      </Grid>
                      <Grid
                        container
                        xs={8}
                        lg={8}
                        direction="row"
                        sx={{ paddingTop: "10px" }}
                      >
                        <Grid
                          item
                          xs={12}
                          sx={{
                            paddingLeft: "85px",
                          }}
                        >
                          <h1>FUNDAMENTALS</h1>
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          sx={{
                            paddingLeft: "105px",
                            marginTop: "-20px",
                          }}
                        >
                          <h3>Traffic Lights & Signal</h3>
                        </Grid>
                      </Grid>
                      <Grid
                        item
                        xs={2}
                        lg={2}
                        style={{ paddingLeft: "-15px", paddingTop: "50px" }}
                      >
                        <Link to="/fundamentals">
                          <ArrowForwardIosRoundedIcon />
                        </Link>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    lg={12}
                    sx={{
                      textAlign: "center",
                      marginTop: "20px",
                      borderRadius: "20px",
                      backgroundColor: "rgba(255, 255, 255, 0.5)",
                      boxShadow:
                        "rgba(0, 0, 0, 0.4) 0px 2px 4px, rgba(0, 0, 0, 0.3) 0px 7px 13px -3px, rgba(0, 0, 0, 0.2) 0px -3px 0px inset",
                    }}
                  >
                    <Box sx={{}}>
                      <h1>RED LIGHT</h1>
                    </Box>
                  </Grid>
                </Grid>
              </Grid>
              <Grid
                item
                xs={4}
                md={10}
                lg={8}
                sx={{
                  textAlign: "center",
                  marginRight: "-10px",
                }}
              >
                <Grid
                  style={{
                    height: "100%",
                    borderRadius: "20px",
                    backgroundColor: "rgba(255, 255, 255, 0.5)",
                    boxShadow:
                      "rgba(0, 0, 0, 0.4) 0px 2px 4px, rgba(0, 0, 0, 0.3) 0px 7px 13px -3px, rgba(0, 0, 0, 0.2) 0px -3px 0px inset",
                  }}
                >
                  <Box>3</Box>
                </Grid>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default QuizPage;
